import $ from "cash-dom"

export default class GlowModule {

    static name = 'glow'

    constructor(node) {

        if(!window.matchMedia('only screen and (hover: hover) and (pointer: fine)').matches) return

        const $left = $('.glow-left')
        const $right = $('.glow-right')
        const $bottom = $('.glow-bottom')

        $(node)
            .on('mouseover', 'a[href*="/creating/"]', () => {
                $left.addClass('active')
            })
            .on('mouseout', 'a[href*="/creating/"]', () => {
                $left.removeClass('active')
            })
            
            .on('mouseover', 'a[href*="/performing/"]', () => {
                $right.addClass('active')
            })
            .on('mouseout', 'a[href*="/performing/"]', () => {
                $right.removeClass('active')
            })

            .on('mouseover', 'a[href^="/"]:not([href*="/creating/"]):not([href*="/performing/"])', () => {
                $bottom.addClass('active')
            })
            .on('mouseout', 'a[href^="/"]:not([href*="/creating/"]):not([href*="/performing/"])', () => {
                $bottom.removeClass('active')
            })
    }
}